module.exports = __webpack_public_path__ + "static/media/resourceBookletPdf.a2bff091.pdf";